import HelloDataMark from '../pages/HelloDataMark';
import { Home, Search, LocationOn } from '@mui/icons-material';
import { useEffect, useState } from 'react';

export default function CenterLoader() {
    const [currentIcon, setCurrentIcon] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIcon((prev) => (prev + 1) % 3);
        }, 800);
        return () => clearInterval(interval);
    }, []);

    const icons = [
        { icon: Home, color: '#3176BC', label: 'Finding properties' },
        { icon: Search, color: '#4A90E2', label: 'Searching listings' },
        { icon: LocationOn, color: '#6BA3E8', label: 'Locating in Mallorca' },
    ];

    return (
        <div className="w-full h-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-8 max-w-md w-full px-8">
                {/* Logo */}
                <div className="w-48 flex items-center justify-center mb-4">
                    <HelloDataMark />
                </div>

                {/* Animated Icons */}
                <div className="relative flex items-center justify-center mb-6">
                    <div className="relative w-20 h-20">
                        {icons.map((item, index) => {
                            const IconComponent = item.icon;
                            const isActive = index === currentIcon;
                            return (
                                <div
                                    key={index}
                                    className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${
                                        isActive ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                                    }`}
                                >
                                    <div className={`relative ${isActive ? 'animate-pulse' : ''}`}>
                                        <IconComponent
                                            style={{
                                                fontSize: '2.5rem',
                                                color: item.color,
                                                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                                            }}
                                        />
                                        {isActive && <div className="absolute inset-0 bg-blue-200 rounded-full animate-ping opacity-20"></div>}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Loading Text */}
                <div className="text-center">
                    <div className="text-my-blue text-2xl font-bold mb-2">{icons[currentIcon].label}...</div>
                    <div className="text-gray-600 text-lg">Loading the best deals for you</div>
                </div>

                {/* Progress Bar */}
                <div className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden">
                    <div
                        className="h-full bg-gradient-to-r from-my-blue to-blue-400 rounded-full transition-all duration-300 ease-out"
                        style={{
                            width: `${((currentIcon + 1) / 3) * 100}%`,
                            boxShadow: '0 0 10px rgba(49, 118, 188, 0.3)',
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
}
